<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'fleet_reports.monthly_quarterly_battery_usage_report' | translate}}
			</h4>
		</div>
	</div>

	<div class="row col-xl-12 mb-4">
		<!-- years list -->
		<div class="col-xl-3 col-md-3">
			<label for="year">{{'g.year' | translate}}</label>
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="selectedYear" (ngModelChange)="selectYear()" [clearable]="false">
			</ng-select>
		</div>

		<!-- Monthly or Quarterly drop-down -->
		<div class="col-xl-3 col-md-3" *ngIf="!isAllYearsSelected()">
			<label for="period">{{'perf_analytic.period' | translate}}</label>
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id" placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType" (ngModelChange)="changePeriodType()" [clearable]="false">
			</ng-select>
		</div>
	</div>

	<div class="row col-xl-12 mb-4">
		<div class="col-xl-3 col-md-3">
			<!-- voltage filter -->
			<label for="warning">{{'fleet_reports.battery_voltage' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryVoltage"
				[items]="batteryVoltagesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="getMonthlyQuarterlyBatteryUsageReport()"
			></ng-select>
		</div>
		<div class="col-xl-3 col-md-3">
			<!-- capacity filter -->
			<label for="warning">{{'devices.battery_capacity' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryCapacity"
				[items]="batteryCapacitiesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="getMonthlyQuarterlyBatteryUsageReport()"
			></ng-select>
		</div>
		<!-- Manufacturer filter -->
		<div class="col-xl-3 col-md-3">
			<label for="battery_manufacturer">{{"devices.battery_manufacturer" | translate}}</label>
			<ng-select
				class="select"
				[(ngModel)]="selectedBatteryManufacturer"
				[items]="batteryManufacturersOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(ngModelChange)="getMonthlyQuarterlyBatteryUsageReport()"
				[placeholder]="'devices.battery_manufacturer' | translate"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="col-xl-3 col-md-3">
			<label for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
			<ng-select
				name="batteryVintageSelect"
				id="batteryVintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptionsDropdown"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.battery_vintage' | translate"
				[(ngModel)]="selectedBatteryVintage"
				(change)="batteryVintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div>
	</div>

	<!-- table -->
	<div class="col-12">
		<sct-custom-table
			#sctCustomTable
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
		></sct-custom-table>
	</div>
</div>
